// export const bp = {
//   sm: 'screen and (max-width: 640px)',
//   md: 'screen and (max-width: 768px)',
//   lg: 'screen and (max-width: 1024px)',
//   xl: 'screen and (max-width: 1280px)',
// };

export const breakpoints = {
  // xsm: `screen and (max-width: 375px)`,
  // sm: `screen and (max-width: 425px)`,
  // md: `screen and (max-width: 768px)`,
  // lg: `screen and (max-width: 1024px)`,
  // xlg: `screen and (max-width: 1440px)`,

  xsm: '375px',
  sm: '425px',
  md: '768px',
  lg: '1024px',
  xlg: '1440px',
  // xxlg: `(min-width: 2560px)`,
};
